import React, { useEffect, useRef, useState } from 'react';
import { Route, Link, Switch, useLocation, Redirect } from 'react-router-dom';
import { useAppDispatch, useTypedSelector } from 'store/index';
import { fetchAppTypeOptions, getCsIndustryTree } from 'store/manager';
import { logout } from 'store/user';
import { Menu, Dialog } from '@tencent/spaui';
// @ts-ignore
import { activeAccountType } from 'common/const';
import useRoutes from './routes';
import './index.scss';
import { report } from 'store/report';
import qs from 'qs';

const LinkComponent = (props: any) => {
  const { href, children, ...otherProps } = props;
  return href ? (
    <span {...otherProps}>
      <Link to={href}>{children}</Link>
    </span>
  ) : (
    <a {...otherProps}>{children}</a>
  );
};

const Layout = () => {
  const containerRef = useRef<any>();
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();
  const user = useTypedSelector((state) => state.user.user);
  const userLoading = useTypedSelector((state) => state.user.loading);
  const [isReport, setIsReport] = useState(false);
  const Routes = useRoutes();

  const isProxyAgnecy = user?.active_account_type === activeAccountType.proxyAgency;

  // 入口埋点
  useEffect(() => {
    const query = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    const payload: any = query.source || '';
    report({ event: 'isv_manage_entry', payload });
    setTimeout(setIsReport, 0, true);
  }, []);

  useEffect(() => {
    dispatch(fetchAppTypeOptions());
    dispatch(getCsIndustryTree());
    /* eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, []);

  if (userLoading) {
    return null;
  }

  return user?.operator_id ? (
    <main className="manage-page">
      <Menu
        value={pathname}
        data={Routes?.menus}
        LinkComponent={LinkComponent}
        onChange={() => containerRef?.current?.scrollTo?.(0, 0)}
      />
      <div className="manage-page-container" id="managePageContainer" ref={containerRef}>
        <Switch>
          {Routes?.routes?.map((v) => {
            return <Route key={v.href} path={v.href} component={v.component} exact={v.exact} />;
          })}
          {!!isProxyAgnecy && <Redirect to="/manage/order" />}
          {!!isReport && <Redirect to="/manage/agency/basic" />}
        </Switch>
        {Routes && Routes?.routes.length === 0 && <div>暂无权限</div>}
      </div>
    </main>
  ) : (
    <Dialog
      useNewUI={true}
      size="middle"
      title="提示"
      cancelButton={false}
      onSubmit={() => {
        dispatch(logout());
        window.location.replace('/');
      }}
    >
      <div>{user ? '当前登录用户未注册营销服务市场，请注册后再登录' : '登录态已失效，请重新登录'}</div>
    </Dialog>
  );
};

export default Layout;
